import { useState } from "react";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import { fetchAPI } from "../components/service/Encrtyption";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { convertMediaUrls } from "./authenticatedImages";

export const parseQueryParams = (queryString) => {
  const params = new URLSearchParams(queryString);
  const queryParams = {};

  for (const [key, value] of params) {
    queryParams[key] = value;
  }

  return queryParams;
};

export const useParamarshDetails = () => {
  // debugger;
  const formData = {
    cashFreeTransactionId: 0,
    dsrId: 0,
    ecouponFarmerMapId: 0,
    moduleType: "Farmer",
    programId: 0,
    reClaim: "No",
    showView: false,
    countOfToBeClaims: 0,
    dsrProgramId: 0,
    ecouponFarmerId: 0,
    enableSprayService: false,
    isCortevaProduct: false,
    isLumivia: false,
    isProductAlreadyScaned: false,
    isSpinDone: false,
    lumiviaServReqRecordID: 0,
    multipleRewards: false,
    seadProgramId: 0,
    showClickableLink: false,
    showLuckyWinnerPopup: false,
    showRetailerIdPopup: false,
    uq_responseCode: 0,
    wheelStoppingIndex: 0,
    destinationURL: "/cashFreeReward/getCashFreeTransactionPendingRequest_V3",
  };
  const [rewardsData, setRewardsData] = useState([]);
  const [reclaimData, setReclaimData] = useState([]);
  const [cashRewardsData, setCashRewards] = useState("");
  const [reclaimRewards, setReclaimRewards] = useState([]);
  const [errroMsg, setErrorMsg] = useState("");
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();
  const currentLanguage = lang ? lang : i18n.language;
  const [loader, setLoader] = useState(false);

  const hide = () => {
    setErrorMsg("");
  };

  const user = useSelector((state) => state.user);
  // const fetchData = async () => {
  //   //debugger;
  //   //  const mobileNumber = user?.mobileNumber;
  //   const mobileNumber = sessionStorage.getItem('mbn');

  //   if (!mobileNumber) {
  //     // setErrorMsg(t("sessionExperied"));
  //     setTimeout(() => {
  //       navigate(`/${lang}/home`);
  //     }, 2000);
  //     return;
  //   }

  //   try {
  //     const responseData = await fetchAPI(
  //       process.env.REACT_APP_API_URL,
  //       formData,
  //       {
  //         mobileNumber: mobileNumber,
  //         appLangCode: currentLanguage
  //       }
  //     );
  //     // debugger;
  //     const jsonReposneData = JSON.parse(responseData);
  //     const claimList = jsonReposneData?.cbTransactionList?.cbClaimList;
  //     const reClaimList = jsonReposneData?.cbTransactionList?.cbReClaimList;
  //     const generateClaimIDs = () => {
  //       return claimList.map((item) => ({
  //         benfTransactionId: "",
  //         dsrProgramId: 0,
  //         ecouponFarmerMapId: 0,
  //         seadProgramId: 0,
  //         serverRecordId: item?.serverRecordId,
  //       }));
  //     };
  //     const generateReclaim = () => {
  //       return reClaimList.map((item) => ({
  //         benfTransactionId: "",
  //         dsrProgramId: 0,
  //         ecouponFarmerMapId: 0,
  //         seadProgramId: 0,
  //         serverRecordId: item?.serverRecordId,
  //       }));
  //     };
  //     const generatecashRewards = () => {
  //       const totalCashRewards = claimList?.reduce(
  //         (total, item) => total + parseFloat(item?.cashRewards),
  //         0
  //       );
  //       return totalCashRewards?.toFixed(2);
  //     };

  //     const generateReclaimcashRewards = () => {
  //       const totalCashRewards = reClaimList?.reduce(
  //         (total, item) => total + parseFloat(item?.amount),
  //         0
  //       );
  //       return totalCashRewards?.toFixed(2);
  //     };
  //     const cashRewardsSum = generatecashRewards();
  //     const reclaimRewards = generateReclaimcashRewards();
  //     setRewardsData(generateClaimIDs());
  //     setReclaimData(generateReclaim());
  //     setCashRewards(cashRewardsSum);
  //     setReclaimRewards(reclaimRewards);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     return [null, null, null, null, null,null];
  //   }
  // };

  const fetchData = async () => {
    // alert("fetchData called");
    const mobileNumber = sessionStorage.getItem("mbn");

    if (!mobileNumber) {
      setTimeout(() => {
        navigate(`/${lang}/home`);
      }, 2000);
      return;
    }

    setLoader(true); // Start loader

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          mobileNumber: mobileNumber,
          appLangCode: currentLanguage,
        }
      );


      const ReposneData = JSON.parse(responseData);
      const jsonReposneData = await convertMediaUrls(ReposneData);
      console.log(ReposneData, "otp response ReposneData data");
      console.log("jsonReposneData from UTILS", jsonReposneData);
      const claimList = jsonReposneData?.cbTransactionList?.cbClaimList || [];
      const reClaimList = jsonReposneData?.cbTransactionList?.cbReClaimList || [];

      const generateClaimIDs = () => {
        return claimList.map((item) => ({
          benfTransactionId: "",
          dsrProgramId: 0,
          ecouponFarmerMapId: 0,
          seadProgramId: 0,
          serverRecordId: item?.serverRecordId,
        }));
      };

      const generateReclaim = () => {
        return reClaimList.map((item) => ({
          benfTransactionId: "",
          dsrProgramId: 0,
          ecouponFarmerMapId: 0,
          seadProgramId: 0,
          serverRecordId: item?.serverRecordId,
        }));
      };

      const cashRewardsSum = claimList.reduce((total, item) => total + parseFloat(item?.cashRewards || 0), 0).toFixed(2);

      console.log("cashRewardsSum from UTILS", cashRewardsSum);
      console.log("claimIDs from UTILS", generateClaimIDs());

      const reclaimRewardsSum = reClaimList
        .reduce((total, item) => total + parseFloat(item?.amount || 0), 0)
        .toFixed(2);

      setRewardsData(generateClaimIDs());
      setReclaimData(generateReclaim());
      setCashRewards(cashRewardsSum);
      setReclaimRewards(reclaimRewardsSum);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false); // Stop loader
    }
  };

  return [fetchData, rewardsData, reclaimRewards, reclaimData, cashRewardsData, loader];
};


export const initGA = (trackingID) => {
  ReactGA.initialize(trackingID);
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
};